import styled, { keyframes, css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

const show = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-9px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const showAnimation = css`
  animation: ${show} 0.25s cubic-bezier(0, 1, 1, 1);
`;

export const Card = styled.div`
  opacity: 1;
  width: 100%;
  text-align: left;
  ${showAnimation};
`;

export const CardInner = styled.div`
  border-style: solid;
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-bottom: 15px;
  content: '';
  background-color: #fff;
`;

export const Tagline = styled.div`
  margin-top: ${({ extraMargin }) => (extraMargin ? '9px' : '6px')};
  ${getFont(-1, 'compact')}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.fontL};
`;

export const CardTitle = styled.a`
  display: flex;
  align-items: center;
  ${getFont(0, 'compact')}
  font-weight: 600;
  color: currentColor;

  &:hover {
    color: ${({ theme }) => theme.linkColor};
  }

  span {
    margin-left: 4px;
  }
`;

export const CardText = styled.div`
  ${({ centered }) => (centered ? 'align-self: center;' : null)};
  margin-top: -15px;
  word-wrap: break-word;
`;

export const CardSubTitle = styled.div`
  display: block;
  margin-top: -25px;
  font-weight: 400;
  line-height: 14px;
  ${getFont(-1, 'compact')}
  color: ${({ theme }) => theme.terciaryS};

  a {
    color: ${({ theme }) => theme.linkColor};
  }
`;

export const CardInfo = styled.div`
  display: flex;
  padding: ${({ padding }) => (padding ? padding : '15px 5px')};
  color: ${({ theme }) => theme.colors.font};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: -42px;
  margin-left: 79px;
  ${getFont(-1, 'compact')}
  font-weight: 600;
  white-space: nowrap;
  text-align: left;

  a,
  span {
    position: relative;
    padding: 3.5px 9px;
    border: 1px solid ${({ theme }) => theme.borderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    margin-left: 9px;
    margin-right: 3px;
    cursor: pointer;
    color: black;

    &:hover {
      border-color: ${({ theme }) => theme.followHoverColor};
      background-color: ${({ theme }) => theme.followHoverColor};
      color: ${({ theme }) => theme.followHoverFontColor};
    }

    &:after {
      position: absolute;
      top: -3px;
      bottom: -3px;
      right: 0;
      content: '';
    }
  }

  ${({ theme, isRefuse }) =>
    (isRefuse === true
      ? ''
      : `span {
      border: 1px solid ${theme.colors.terciaryM};
      color: ${theme.colors.terciaryM};
      cursor: default;

      &:hover {
        border: 1px solid ${theme.colors.terciaryM};
        background-color: transparent;
        color: ${theme.colors.terciaryM};
      }
    }`)}
`;
